import { render, staticRenderFns } from "./TicketsByRoutePerDay.vue?vue&type=template&id=72413f20"
import script from "./TicketsByRoutePerDay.vue?vue&type=script&lang=js"
export * from "./TicketsByRoutePerDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports